import { Navigate, useParams } from "react-router";

import { caseActionPath, ROUTES } from "@/app/routes";
import { Skeleton } from "@/components/ui/skeleton";
import { useTaskForm } from "@/features/new-application/use-start-application";

/**
 * 旧・入力画面（`/tasks/:caseId/:taskGuid`）を案件詳細へ送り直す。
 *
 * 提出の画面は案件詳細の操作パネルに一本化した（同じ操作の画面を 2 つ持たない）。
 * ただしこの URL は消せない:
 *  - 利用者のブックマーク・共有リンク
 *  - **backend が組む通知の URL**（`get_url_for_task_with_bpmn_identifier` は
 *    `{フロントの URL}/tasks/{案件}/{タスク}` を返す。Slack 通知がこれを使う）
 *
 * 案件詳細はモデル id を URL に要求するが、この URL には無いのでタスクから取る。
 * 取れないとき（完了済み・権限が無い）はマイ案件へ逃がす。
 */
export function TaskRunRedirect() {
  const params = useParams();
  const caseId = Number.parseInt(params.caseId ?? "", 10);
  const taskGuid = params.taskGuid ?? "";

  const isValid = Number.isFinite(caseId) && taskGuid !== "";
  const form = useTaskForm(isValid ? { caseId, taskGuid } : null);

  if (!isValid) return <Navigate to={ROUTES.myApplications} replace />;
  if (form.isPending) return <Skeleton className="h-24 w-full" />;

  const processModelId = form.data?.processModelId ?? null;
  if (processModelId === null) {
    return <Navigate to={ROUTES.myApplications} replace />;
  }

  return <Navigate to={caseActionPath(caseId, processModelId)} replace />;
}
